export function takeProperty(property, newObj, oldObj) {
	if(oldObj && oldObj.hasOwnProperty(property)) {
		newObj[property] = oldObj[property];
	}
}
